import { days } from "components/utils/option";
import { lngProps } from "interface/index";
import i18n from "locales/i18n";
import { useGetRoomStatusData } from "../service";
import { Fragment, useEffect, useRef } from "react";
import { CalendarCardInfProvider, useCalendarContext } from "../context";
import Card from "./card";
import { getKoreanCalendarDates } from "components/utils/comm";

export default function CalendarBody() {
  const langCd = i18n.language;
  const { now } = useCalendarContext();
  const calendarDates = getKoreanCalendarDates(now);

  const { pdList } = useGetRoomStatusData({
    start: calendarDates[0]?.fullDate,
    end: calendarDates.at(-1)?.fullDate,
  });

  const todayRef = useRef<HTMLLIElement>(null);

  // 오늘날짜 주일로 자동 스크롤 이동하기
  useEffect(() => {
    if (todayRef.current) {
      todayRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [pdList]);

  return (
    <>
      <ul className="calendar-rm days">
        {days.map((day) => {
          return <li key={day.value}>{day[langCd as keyof lngProps]}</li>;
        })}
      </ul>

      <ul className="calendar-rm week">
        {calendarDates.map((date) => {
          const rmPds = pdList?.find((rmpd) => {
            return rmpd.sellDt === date.fullDate;
          });

          return (
            <Fragment key={date.fullDate}>
              <CalendarCardInfProvider>
                <Card
                  week={date}
                  rmPds={rmPds}
                  ref={date.isToday ? todayRef : null}
                />
              </CalendarCardInfProvider>
            </Fragment>
          );
        })}
      </ul>
    </>
  );
}
